import { useEffect, useState } from 'react';
import {
  READ_STORE_EVENT,
  clearReadStoreNotices,
  readStoreNotices,
} from '@/lib/readStoreNotice.js';

// Some of what is on screen came from TRACON's own records, and these fields
// are not in them yet (review A-R5). Renders only after a response answered
// from Supabase (X-TRACON-Read-Store); with every read-store flag on zoho it
// renders nothing. Each not-carried field is answered blank by the API, so
// without this line a blank would read as "nobody has this", which is not what
// it means. Kept for the session (a page served from the client cache makes no
// new response, so clearing on navigation would hide a notice that still
// applies); "Dismiss" clears it until the next such response.
export default function ReadStoreNotice() {
  const [notices, setNotices] = useState(() => readStoreNotices());
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onChange = () => setNotices(readStoreNotices());
    window.addEventListener(READ_STORE_EVENT, onChange);
    return () => window.removeEventListener(READ_STORE_EVENT, onChange);
  }, []);

  if (!notices.length) return null;
  const fields = [...new Set(notices.flatMap((n) => n.notCarried))];

  return (
    <div className="border-b border-border bg-warning-soft px-4 py-2 text-sm text-text" role="status">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <span className="font-medium">Reading TRACON&apos;s own records.</span>
        <span className="text-text-muted">
          {fields.length
            ? `${fields.length} field${fields.length === 1 ? ' is' : 's are'} not in TRACON yet and show blank.`
            : 'Every field read this way is in TRACON.'}
        </span>
        {fields.length ? (
          <button type="button" className="underline" onClick={() => setOpen((v) => !v)}>
            {open ? 'Hide' : 'Show which'}
          </button>
        ) : null}
        <button type="button" className="ml-auto underline" onClick={() => { setOpen(false); clearReadStoreNotices(); }}>
          Dismiss
        </button>
      </div>
      {open ? (
        <ul className="mt-2 space-y-1 text-text-muted">
          {notices.map((n) => (
            <li key={n.path}>
              <span className="font-mono text-xs">{n.path}</span>
              {n.status !== 200 ? <span> (answered {n.status})</span> : null}
              {n.notCarried.length ? <span>: {n.notCarried.join('; ')}</span> : null}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
